import Base from "./base";

export default class Trezuz extends Base {
	makeExternalPayment(newStep) {
		const { stake, selectedCurrency } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(stake),
				currency: selectedCurrency,
				method: this.props.externalFunc.method,
				claimsBonus: false,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { stake, selectedCurrency } = this.state;
		this.props.externalFunc.makeDeposit(
			{
				amount: parseInt(stake),
				claimsBonus: true,
				bonusId: bonusId,
				currency: selectedCurrency,
				method: this.props.externalFunc.method,
			},
			(data) => {
				this.setState({
					externalUrl: data.url,
					currentStep: newStep,
				});
			}
		);
	}
}
